import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  WSButton,
  WSFlexBox,
  WSText,
  WSTimeline
} from "@wingspanhq/fe-component-library";
import {
  Form1099Status,
  ICollaboratorSchema,
  IMemberClientForm1099Balances,
  IPayrollSettings
} from "@wingspanhq/payments/dist/interfaces";

import LabelValueList, {
  LIST_MT,
  LABEL_COLOR,
  ListElement
} from "../../../components/LabelValueList";
// import DropdownButton from "../../../components/DropdownButton";
import { SidePanelSection } from "../../../components/SidePanel";
import getDetailsAndSettingsItems from "../../utils/getDetailsAndSettingsItems";
import { getBusinessTypeLabel } from "../../../Settings/components/SettingsUpdateForms/BusinessTypeForm";
import {
  getPayeeInfoOtherItems,
  getPayeeInfoW9EditItems
} from "../../utils/payee-info";
import getTotalsItems from "../../utils/getTotalsItems";
import { TaxFormStatusBadge } from "../../components/TaxFormStatusBadge";
import getCompanyStructure from "../../utils/getCompanyStructure";
import getCollaboratorName from "../../utils/getCollaboratorName";
import { getActivityFrom1099Events } from "../../utils";

import CombinedEligibility from "./CombinedEligibility";
import ExclusionReasonInfo from "./ExclusionReasonInfo";

interface ContentProps {
  title: string;
  collaborator: ICollaboratorSchema;
  currentForm1099Balance: IMemberClientForm1099Balances | undefined;
  payrollSettings: IPayrollSettings;
}

const Content: React.FC<ContentProps> = ({
  title,
  collaborator,
  currentForm1099Balance,
  payrollSettings
}) => {
  const history = useHistory();
  const location = useLocation();
  const form1099Status = currentForm1099Balance?.status;

  // const buttonMenuItems = useMemo(
  //   () => [
  //     // {
  //     //   label: "Example action",
  //     //   onClick() {
  //     //     alert("This is example action");
  //     //   }
  //     // }
  //   ],
  //   []
  // );

  // TODO: isCombinedEligibility is mocked data to be replaced with actual logic
  const isCombinedEligibility = false;
  const titleAside = isCombinedEligibility ? <CombinedEligibility /> : null;

  const activity = getActivityFrom1099Events(collaborator);

  return (
    <>
      <SidePanelSection first>
        <WSFlexBox.CenterY wrap="nowrap" justify="space-between">
          <WSText.Heading3 data-testid="clientName">
            {getCollaboratorName(collaborator)}
          </WSText.Heading3>
          {form1099Status && <TaxFormStatusBadge status={form1099Status} />}
        </WSFlexBox.CenterY>

        {form1099Status === Form1099Status.Excluded && (
          <ExclusionReasonInfo
            reason={currentForm1099Balance?.exclusionReason}
          />
        )}

        {/* <DropdownButton
          fullWidth
          mt="L"
          name="actions"
          title="Actions"
          text={`Edit ${title}`}
          onClick={() => {
            history.push(`${location.pathname}/edit`);
          }}
          menuItems={buttonMenuItems}
        /> */}

        <WSButton
          fullWidth
          mt="L"
          name="actions"
          title="Actions"
          onClick={() => {
            history.push(`${location.pathname}/edit`);
          }}
        >{`Edit ${title}`}</WSButton>
      </SidePanelSection>

      <SidePanelSection title="Totals" titleAside={titleAside}>
        <LabelValueList
          items={
            currentForm1099Balance && getTotalsItems(currentForm1099Balance)
          }
        />
      </SidePanelSection>

      <SidePanelSection title="Payee information">
        <WSFlexBox justify="space-between" mt={LIST_MT}>
          <ListElement color={LABEL_COLOR} value="Company type" />
          <ListElement
            value={
              getBusinessTypeLabel(getCompanyStructure(collaborator)) || "-"
            }
          />
        </WSFlexBox>
        <LabelValueList items={getPayeeInfoW9EditItems(collaborator)} />
        <WSFlexBox justify="space-between" mt={LIST_MT}>
          <ListElement color={LABEL_COLOR} value="State" />
          <ListElement value={collaborator.formW9Data?.state || "-"} />
        </WSFlexBox>
        <LabelValueList items={getPayeeInfoOtherItems(collaborator)} />
        <WSFlexBox justify="space-between" mt={LIST_MT}>
          <ListElement color={LABEL_COLOR} value="External Contractor ID" />
          <ListElement
            value={
              (collaborator.clientData && collaborator.clientData.externalId) ||
              "-"
            }
          />
        </WSFlexBox>
      </SidePanelSection>

      <SidePanelSection title="Form details & calculation settings">
        <LabelValueList
          items={getDetailsAndSettingsItems(
            payrollSettings,
            currentForm1099Balance?.type
          )}
        />
      </SidePanelSection>

      <SidePanelSection title="Activity">
        {activity.length > 0 ? (
          <WSTimeline timelines={activity} />
        ) : (
          <WSText mt={LIST_MT} color={LABEL_COLOR}>
            No events found
          </WSText>
        )}
      </SidePanelSection>
    </>
  );
};

export default Content;
